import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function ShoppingBagIcon({ className, width = 17, height = 17 }: IconProps) {
    return (
        <svg
            className={cn('text-gray-400', className)}
            width={width}
            height={height}
            viewBox='0 0 17 17'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M11.6803 16.1144H5.31239C4.09406 16.1144 3.18031 15.7886 2.61364 15.144C2.04698 14.4994 1.82739 13.5644 1.97614 12.3532L2.61364 7.04067C2.79781 5.47526 3.19448 4.07275 5.95698 4.07275H11.057C13.8124 4.07275 14.2091 5.47526 14.4003 7.04067L15.0378 12.3532C15.1795 13.5644 14.967 14.5065 14.4003 15.144C13.8124 15.7886 12.9057 16.1144 11.6803 16.1144ZM5.94989 5.13525C3.90989 5.13525 3.81072 5.94274 3.66197 7.16108L3.02448 12.4736C2.91823 13.3732 3.04572 14.0319 3.40697 14.4357C3.76822 14.8394 4.40573 15.0448 5.31239 15.0448H11.6803C12.587 15.0448 13.2245 14.8394 13.5857 14.4357C13.947 14.0319 14.0745 13.3732 13.9682 12.4736L13.3307 7.16108C13.182 5.93566 13.0899 5.13525 11.0428 5.13525H5.94989Z'
                fill='currentColor'
            />
            <path
                d='M11.3333 6.19775C11.0429 6.19775 10.802 5.95692 10.802 5.6665V3.18734C10.802 2.42234 10.3275 1.94775 9.56246 1.94775H7.43746C6.67246 1.94775 6.19788 2.42234 6.19788 3.18734V5.6665C6.19788 5.95692 5.95704 6.19775 5.66663 6.19775C5.37621 6.19775 5.13538 5.95692 5.13538 5.6665V3.18734C5.13538 1.83442 6.08454 0.885254 7.43746 0.885254H9.56246C10.9154 0.885254 11.8645 1.83442 11.8645 3.18734V5.6665C11.8645 5.95692 11.6237 6.19775 11.3333 6.19775Z'
                fill='currentColor'
            />
            <path
                d='M14.457 12.5942H5.66663C5.37621 12.5942 5.13538 12.3534 5.13538 12.063C5.13538 11.7726 5.37621 11.5317 5.66663 11.5317H14.457C14.7475 11.5317 14.9883 11.7726 14.9883 12.063C14.9883 12.3534 14.7475 12.5942 14.457 12.5942Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default ShoppingBagIcon;

